module.exports = "<footer>\n    <div class=\"container\">\n      <p>&copy; 2019 Kelsa Solutions Pvt. Ltd. All Rights Reserved.</p>\n      </div>\n  </footer>"